/** 生图侧栏：与全局 angular / 圆角策略一致 */

export function createPanelRound(angular: boolean): string {
  return angular ? 'rounded-none' : 'rounded-2xl'
}

export function createPanelRoundSm(angular: boolean): string {
  return angular ? 'rounded-none' : 'rounded-xl'
}

export function createPanelRoundMd(angular: boolean): string {
  return angular ? 'rounded-none' : 'rounded-lg'
}

export function createSectionLabelClass(): string {
  return 'text-xs sm:text-[13px] font-semibold uppercase tracking-[0.08em] text-ink'
}

export function createSubcardClass(angular: boolean): string {
  return [
    'create-settings-subcard bg-surface-muted/35 p-2.5',
    createPanelRoundSm(angular),
  ].join(' ')
}
